import { IconProps } from '.'
import BaseSvg from './BaseSvg'

// TODO Remove the onClick!
const Calendar = ({ title = 'Calendar', onClick, ...rest }: IconProps & { onClick: () => void }) => (
  <BaseSvg onClick={onClick} viewBox="0 0 16 16" title={title} {...rest}>
    <path
      fill="currentColor"
      d="M15,2h-2V0h-3v2H6V0H3v2H1C0.448,2,0,2.448,0,3v12c0,0.552,0.448,1,1,1h14c0.552,0,1-0.448,1-1V3 C16,2.448,15.552,2,15,2z M14,14H2V5h12V14z"
    />
    <rect fill="currentColor" x="4" y="7" width="2" height="2" />
    <rect fill="currentColor" x="7" y="7" width="2" height="2" />
    <rect fill="currentColor" x="4" y="10" width="2" height="2" />
    <rect fill="currentColor" x="7" y="10" width="2" height="2" />
    <rect fill="currentColor" x="10" y="7" width="2" height="2" />
    <rect fill="currentColor" x="10" y="10" width="2" height="2" />
  </BaseSvg>
)

Calendar.displayName = 'Calendar'
Calendar.needsWork = true
export default Calendar
